/**
 * Motivos do campo de mensagem desativado numa negociação. O detalhe e a Central de Atendimentos
 * exibem o mesmo texto, e manter as duas cópias em sincronia à mão foi o que as fez divergir.
 */
export const AVISO_NEGOCIACAO_ARQUIVADA =
  'Negociação arquivada. O envio de mensagens está desativado.';

export const AVISO_NEGOCIACAO_CONCLUIDA =
  'Negociação concluída. O envio de mensagens está desativado.';
